import { render } from "./TopBlock.vue?vue&type=template&id=41ea10e8&scoped=true"
import script from "./TopBlock.vue?vue&type=script&lang=js"
export * from "./TopBlock.vue?vue&type=script&lang=js"

import "./TopBlock.vue?vue&type=style&index=0&id=41ea10e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ea10e8"]])

export default __exports__